import { render, staticRenderFns } from "./OrganizationDeleteInvitationCollaboratorDialog.vue?vue&type=template&id=2cb7fc71&scoped=true"
import script from "./OrganizationDeleteInvitationCollaboratorDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationDeleteInvitationCollaboratorDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDeleteInvitationCollaboratorDialog.vue?vue&type=style&index=0&id=2cb7fc71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7fc71",
  null
  
)

export default component.exports